import type { Template } from "@/types";

export const PO_07_H0_V7: Template[] = [
    {
        id: "po-07-h0v7-01",
        name: "PO 01 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 264, width: 173, height: 256, rotation: 0, imageRotation: 0 },
            { id: "2", x: 180, y: 264, width: 173, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 264, width: 173, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 541, y: 264, width: 172, height: 256, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 264, width: 172, height: 256, rotation: 0, imageRotation: 0 },
            { id: "6", x: 900, y: 264, width: 172, height: 256, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 264, width: 172, height: 256, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-02",
        name: "PO 02 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_02.png",
        size: [1311, 820],
        style: {},
        slots: [      
            { id: "1", x: 62, y: 165, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 165, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "3", x: 422, y: 165, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "4", x: 62, y: 414, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "5", x: 242, y: 414, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "6", x: 422, y: 414, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "7", x: 807, y: 165, width: 352, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-03",
        name: "PO 03 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 161, y: 79, width: 149, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 161, y: 290, width: 149, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 161, y: 500, width: 149, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 317, y: 79, width: 149, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 317, y: 290, width: 149, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 317, y: 500, width: 149, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 723, y: 79, width: 433, height: 624, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-04",
        name: "PO 04 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 34, y: 0, width: 588, height: 820, rotation: 0, imageRotation: 0 },
            { id: "2", x: 697, y: 138, width: 186, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 697, y: 414, width: 186, height: 268, rotation: 0, imageRotation: 0 },
            { id: "4", x: 891, y: 138, width: 186, height: 268, rotation: 0, imageRotation: 0 },
            { id: "5", x: 891, y: 414, width: 186, height: 268, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1085, y: 138, width: 185, height: 268, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1085, y: 414, width: 185, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-05",
        name: "PO 05 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 50, y: 208, width: 260, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 208, width: 127, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 396, width: 127, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 451, y: 208, width: 126, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 451, y: 396, width: 126, height: 180, rotation: 0, imageRotation: 0 },
            { id: "6", x: 675, y: 208, width: 261, height: 368, rotation: 0, imageRotation: 0 },
            { id: "7", x: 943, y: 208, width: 260, height: 368, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-06",
        name: "PO 06 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 59, y: 149, width: 402, height: 486, rotation: 0, imageRotation: 0 },
            { id: "2", x: 673, y: 149, width: 345, height: 486, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 149, width: 113, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 468, y: 314, width: 113, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 468, y: 478, width: 113, height: 157, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1026, y: 149, width: 169, height: 240, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1026, y: 396, width: 169, height: 239, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-07",
        name: "PO 07 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 76, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 396, width: 221, height: 312, rotation: 0, imageRotation: 0 },
            { id: "3", x: 290, y: 76, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "4", x: 290, y: 396, width: 221, height: 312, rotation: 0, imageRotation: 0 },
            { id: "5", x: 518, y: 76, width: 446, height: 632, rotation: 0, imageRotation: 0 },
            { id: "6", x: 971, y: 76, width: 220, height: 313, rotation: 0, imageRotation: 0 },
            { id: "7", x: 971, y: 396, width: 220, height: 312, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-08",
        name: "PO 08 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 76, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 396, width: 221, height: 312, rotation: 0, imageRotation: 0 },
            { id: "3", x: 290, y: 76, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "4", x: 290, y: 396, width: 221, height: 312, rotation: 0, imageRotation: 0 },
            { id: "5", x: 518, y: 76, width: 220, height: 313, rotation: 0, imageRotation: 0 },
            { id: "6", x: 518, y: 396, width: 220, height: 312, rotation: 0, imageRotation: 0 },
            { id: "7", x: 745, y: 76, width: 446, height: 632, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-09",
        name: "PO 09 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 76, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 396, width: 221, height: 312, rotation: 0, imageRotation: 0 },
            { id: "3", x: 290, y: 76, width: 447, height: 632, rotation: 0, imageRotation: 0 },
            { id: "4", x: 744, y: 76, width: 220, height: 313, rotation: 0, imageRotation: 0 },
            { id: "5", x: 744, y: 396, width: 220, height: 312, rotation: 0, imageRotation: 0 },
            { id: "6", x: 971, y: 76, width: 220, height: 313, rotation: 0, imageRotation: 0 },
            { id: "7", x: 971, y: 396, width: 220, height: 312, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-10",
        name: "PO 10 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 185, width: 141, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 395, width: 141, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 149, y: 185, width: 141, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 149, y: 395, width: 141, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 297, y: 185, width: 314, height: 411, rotation: 0, imageRotation: 0 },
            { id: "6", x: 619, y: 185, width: 314, height: 411, rotation: 0, imageRotation: 0 },
            { id: "7", x: 940, y: 185, width: 313, height: 411, rotation: 0, imageRotation: 0 }
        ],
    }
];